import React, {useState} from 'react';
import './blog.css';
import InputField from '../components/input/inputField';

const SubscribeSection = () => {
    const [email, setEmail] = useState('')
  return (
    <div className="subscribe-section">
        <div className='subscribe-left-section'>
      <h2 className='subscribe-title'>Legal Blog</h2>
      <div style={{display: 'flex', padding: '2%',alignItems: 'center', justifyContent: 'center'}}>
      <InputField
          title="Email Address"
          placeholder="E.g connect@quidpro.ai"
          isRequired={true}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="input-spacing"
        />
      <button className="subscribe-button">Subscribe</button>
      </div>
      </div>
      <p className="subscribe-right-section">Explore valuable legal insights, expert tips, and the latest updates from the legal world. Stay informed with articles tailored for clients and professionals alike.</p>
    </div>
  );
};

export default SubscribeSection;
